/** Wires app maintenance and OTA update ports for the composition root. */
import type { AuthStorageAdapter } from '@src/modules/auth/infrastructure/driven/AuthStorageAdapter.ts';
import type { LocalSqliteRuntime } from '@src/modules/shared/local-sqlite/domain/LocalSqliteRuntime.ts';
import {
  AppMaintenanceApplicationService,
  type AppMaintenancePendingUploadGuard,
} from '@src/modules/sync/application/AppMaintenanceApplicationService.ts';
import { AppUpdateApplicationService } from '@src/modules/sync/application/AppUpdateApplicationService.ts';
import type { AppMaintenancePort } from '@src/modules/sync/domain/ports/AppMaintenancePort.ts';
import type { AppUpdatePort } from '@src/modules/sync/domain/ports/AppUpdatePort.ts';
import { createAppMaintenancePort } from '@src/modules/sync/infrastructure/driven/createAppMaintenancePort.ts';
import { createAppUpdatePort } from '@src/modules/sync/infrastructure/driven/createAppUpdatePort.ts';

export type MaintenanceServices = {
  appMaintenance: AppMaintenancePort;
  appUpdate: AppUpdatePort;
};

export function buildMaintenanceServices(opts: {
  localSqlite?: LocalSqliteRuntime;
  authStorage: AuthStorageAdapter;
  pendingUploadGuard?: AppMaintenancePendingUploadGuard;
}): MaintenanceServices {
  const maintenanceBase = createAppMaintenancePort({
    localSqlite: opts.localSqlite,
    tokenStorage: opts.authStorage,
  });
  const appMaintenance = new AppMaintenanceApplicationService(maintenanceBase, opts.pendingUploadGuard);
  const appUpdate = new AppUpdateApplicationService(createAppUpdatePort());
  return { appMaintenance, appUpdate };
}
